/**
 * Set the current page
 *
 * Will trigger new search
 *
 * @param current Integer
 */
export default function setCurrent(current) {
  var _console;

  // eslint-disable-next-line no-console
  if (this.debug) (_console = console).log.apply(_console, ["Search UI: Action", "setCurrent"].concat(Array.prototype.slice.call(arguments)));

  this._updateSearchResults({
    current: current
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NldEN1cnJlbnQuanMiXSwibmFtZXMiOlsic2V0Q3VycmVudCIsImN1cnJlbnQiLCJkZWJ1ZyIsImNvbnNvbGUiLCJsb2ciLCJhcmd1bWVudHMiLCJfdXBkYXRlU2VhcmNoUmVzdWx0cyJdLCJtYXBwaW5ncyI6IkFBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSxlQUFlLFNBQVNBLFVBQVQsQ0FBb0JDLE9BQXBCLEVBQTZCO0FBQUE7O0FBQzFDO0FBQ0EsTUFBSSxLQUFLQyxLQUFULEVBQWdCLFlBQUFDLE9BQU8sRUFBQ0MsR0FBUixrQkFBWSxtQkFBWixFQUFpQyxZQUFqQyxvQ0FBa0RDLFNBQWxEOztBQUVoQixPQUFLQyxvQkFBTCxDQUEwQjtBQUN4QkwsSUFBQUEsT0FBTyxFQUFQQTtBQUR3QixHQUExQjtBQUdEIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBTZXQgdGhlIGN1cnJlbnQgcGFnZVxuICpcbiAqIFdpbGwgdHJpZ2dlciBuZXcgc2VhcmNoXG4gKlxuICogQHBhcmFtIGN1cnJlbnQgSW50ZWdlclxuICovXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzZXRDdXJyZW50KGN1cnJlbnQpIHtcbiAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIG5vLWNvbnNvbGVcbiAgaWYgKHRoaXMuZGVidWcpIGNvbnNvbGUubG9nKFwiU2VhcmNoIFVJOiBBY3Rpb25cIiwgXCJzZXRDdXJyZW50XCIsIC4uLmFyZ3VtZW50cyk7XG5cbiAgdGhpcy5fdXBkYXRlU2VhcmNoUmVzdWx0cyh7XG4gICAgY3VycmVudFxuICB9KTtcbn1cbiJdfQ==